// Finance Department Dashboard — merged from BankingDashboard + AccountsDashboard
// Role: "finance"
import BankingDashboard from "./BankingDashboard";

// Finance department reuses the full banking dashboard UI (loan tracking, cash approvals).
// The accounts/financial-tracking view is accessible via sidebar.
export default BankingDashboard;
